var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',{staticClass:"icon ml-2 text-success",attrs:{"icon":['fas', 'check']}})}
var staticRenderFns = []

export { render, staticRenderFns }